module.exports = __webpack_public_path__ + "static/media/mock_mobile.7858d801.gif";